import { supabase } from "@/integrations/supabase/client";
import React from "react";

interface AuthFooterProps {
  mode: "login" | "signup";
  onModeChange: (mode: "login" | "signup") => void;
  onClose: () => void;
  loading: boolean;
}

const AuthFooter: React.FC<AuthFooterProps> = ({
  mode,
  onModeChange,
  onClose,
  loading,
}) => {
  return (
    <>
      <div className="text-center mt-4">
        <span className="text-white/60 font-inter">
          {mode === "login"
            ? "Don't have an account? "
            : "Already have an account? "}
        </span>
        <button
          onClick={() => onModeChange(mode === "login" ? "signup" : "login")}
          disabled={loading}
          className="text-holo-blue hover:text-electric-yellow font-inter transition-colors disabled:opacity-50"
        >
          {mode === "login" ? "Sign up" : "Sign in"}
        </button>
      </div>
    </>
  );
};

export default AuthFooter;
